import React, { PropsWithChildren } from 'react';
import MarketRegionStateComparisonOutput from '@app/model/market_area/MarketRegionStateComparisonOutput';
import { MarketRegionStateService } from '@app/model/market_area/service/MarketRegionStateService';
import { useQuery } from '@tanstack/react-query';
import { MarketAreaStateQueryKeys } from '@app/model/market_area/service/MarketAreaStateQueryKeys';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import CalendarMonth from '@app/state/calendar/CalendarMonth';

export const MarketAreaStateForMonthContext = React.createContext<MarketRegionStateComparisonOutput[]>([]);

const MarketAreaStateForMonthProvider: React.FunctionComponent<PropsWithChildren<{
	companyHotel: CompanyHotel,
	calendarMonth: CalendarMonth
}>> = ({ companyHotel, calendarMonth, children }) => {

	if (!companyHotel.settings.main.marketAreaId) return children;

	return <MarketAreaStateForMonth companyHotel={companyHotel}
																	fromDate={calendarMonth.range.startStatDate}
																	toDate={calendarMonth.range.endStatDate}>
		{children}
	</MarketAreaStateForMonth>;
};

const MarketAreaStateForMonth: React.FunctionComponent<PropsWithChildren<{
	companyHotel: CompanyHotel,
	fromDate: string,
	toDate: string
}>> = ({ companyHotel, fromDate, toDate, children }) => {
	const { data, isSuccess } = useQuery({
		queryFn: () => MarketRegionStateService.findMarketRegionForPeriodStatesComparison({
			companyHotelId: companyHotel.id,
			fromDate: fromDate,
			toDate: toDate,
		}),
		queryKey: MarketAreaStateQueryKeys.details(companyHotel.settings.main.marketAreaId!, fromDate, toDate),
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: true,
	});

	if (isSuccess) {
		return <MarketAreaStateForMonthContext.Provider
			value={data}>{children}</MarketAreaStateForMonthContext.Provider>;
	}

	return children;

};

export default MarketAreaStateForMonthProvider;